document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.disclosure__button.localization-selector > span')
    .forEach(function (span) {
      span.textContent = span.textContent
        .replace(/\s*\|\s*JOD\s*د\.ا\s*/g, '')
        .trim();
    });
});